import { Icon, LinkButton } from '@saas/ui';

/** 403: 権限不足、または機能フラグで無効なモジュール */
export function ForbiddenPage({ reason = 'permission' }: { reason?: 'permission' | 'module' }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-5 py-16 text-center" role="alert">
      <Icon name="lock" size={28} className="text-fg-tertiary" />
      <h1 className="font-serif text-title">{reason === 'module' ? 'この機能は利用できません' : 'この画面を表示する権限がありません'}</h1>
      <p className="max-w-md text-callout text-fg-secondary">
        {reason === 'module' ? 'ご契約プランに含まれていないか、管理者が無効にしています。管理者に確認してください。' : '必要な権限が付与されていません。管理者に確認してください。'}
      </p>
      <div className="mt-4">
        <LinkButton to="/" variant="secondary" icon="home">
          自分宛てへ戻る
        </LinkButton>
      </div>
    </div>
  );
}
